"use strict";

exports.__esModule = true;
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = _interopRequireDefault(require("../../constants/colors"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tbackground: none;\n\tborder: none;\n\tcolor: ", ";\n\tcursor: pointer;\n\tmargin: 0;\n\tpadding: 0;\n\ttext-align: left;\n\tvertical-align: text-top !important;\n\tfont-family: 'galano', sans-serif;\n\n\t&:hover {\n\t\tbackground: none;\n\t\tborder: none;\n\t\tcolor: ", ";\n\t\ttext-decoration: none;\n\t}\n\n\t&:focus {\n\t\tcolor: ", ";\n\t\ttext-decoration: underline;\n\t}\n\n\t&:disabled {\n\t\tbackground-color: transparent !important;\n\t\tcolor: ", " !important;\n\t\ttext-decoration: none;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var LinkButton = _styledComponents.default.button(_templateObject(), function (props) {
  return props.color === 'secondary' ? _colors.default.secondary : _colors.default.link;
}, function (props) {
  return props.color === 'secondary' ? _colors.default.secondaryDark : _colors.default.linkHover;
}, function (props) {
  return props.color === 'secondary' ? _colors.default.secondaryDark : _colors.default.linkFocus;
}, _colors.default.linkDisabled);

LinkButton.displayName = 'LinkButton';
LinkButton.defaultProps = {
  color: 'primary'
};
LinkButton.propTypes = {
  color: (0, _propTypes.oneOf)(['primary', 'secondary'])
};
/** @component */

var _default = LinkButton;
exports.default = _default;